import type { TNAPIBody } from '~/types/napi-helpers'

function registerEvent(
  eventSlug: string,
  payload: TNAPIBody<'/napis/v1/events/{event_slug}/', 'post'>,
  eventName: string
) {
  const { openAPIFetchOnce } = useAuthFetch()
  const { data: user } = useAuth()
  const { gtag } = useGtag()

  // emit Event_Sign_Up event when user submit event registration form
  gtag('event', 'Event_Sign_Up', {
    event_name: eventName,
    signup_type: getPrimaryUserRole(user.value)
  })

  return openAPIFetchOnce(
    '/napis/v1/events/{event_slug}/',
    'post',
    {
      event_slug: eventSlug
    },
    undefined,
    payload
  )
}

function registerMailList(
  payload: TNAPIBody<'/napis/v1/mail-list/', 'post'>,
) {
  const { openAPIFetchOnce } = useAuthFetch()

  return openAPIFetchOnce('/napis/v1/mail-list/', 'post', undefined, undefined, payload)
}

type UseEventReturnType = {
  registerEvent: typeof registerEvent
  registerMailList: typeof registerMailList
}

export function useEventReg(): UseEventReturnType {
  return {
    registerEvent,
    registerMailList
  }
}
